// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/roboto-condensed-latin-300-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/roboto-condensed-latin-300-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/roboto-condensed-latin-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/roboto-condensed-latin-400-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/roboto-condensed-latin-700-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/roboto-condensed-latin-700-normal.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roboto Condensed - self-hosted via src/fonts/ (copied from @fontsource/roboto-condensed) */

/* Weight 300 — Light */
@font-face {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

/* Weight 400 — Regular */
@font-face {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}

/* Weight 700 — Bold */
@font-face {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}

/* App-wide default font */
body {
    font-family: "Roboto Condensed", Arial, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/fonts.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F,uBAAuB;AACvB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;8DAEwE;AAC5E;;AAEA,yBAAyB;AACzB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;8DAEwE;AAC5E;;AAEA,sBAAsB;AACtB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;8DAEwE;AAC5E;;AAEA,0BAA0B;AAC1B;IACI,kDAAkD;AACtD","sourcesContent":["/* Roboto Condensed - self-hosted via src/fonts/ (copied from @fontsource/roboto-condensed) */\n\n/* Weight 300 — Light */\n@font-face {\n    font-family: \"Roboto Condensed\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 300;\n    src:\n        url(\"./fonts/roboto-condensed-latin-300-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/roboto-condensed-latin-300-normal.woff\") format(\"woff\");\n}\n\n/* Weight 400 — Regular */\n@font-face {\n    font-family: \"Roboto Condensed\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 400;\n    src:\n        url(\"./fonts/roboto-condensed-latin-400-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/roboto-condensed-latin-400-normal.woff\") format(\"woff\");\n}\n\n/* Weight 700 — Bold */\n@font-face {\n    font-family: \"Roboto Condensed\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 700;\n    src:\n        url(\"./fonts/roboto-condensed-latin-700-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/roboto-condensed-latin-700-normal.woff\") format(\"woff\");\n}\n\n/* App-wide default font */\nbody {\n    font-family: \"Roboto Condensed\", Arial, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
